import { render, staticRenderFns } from "./Update.vue?vue&type=template&id=27efc2b2&scoped=true&"
import script from "./Update.vue?vue&type=script&lang=js&"
export * from "./Update.vue?vue&type=script&lang=js&"
import style0 from "./Update.vue?vue&type=style&index=0&id=27efc2b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27efc2b2",
  null
  
)

export default component.exports